import "./index.css";

export const Input = ({
  id,
  error,
  label,
  value,
  type = "text",
  isRequired = false,
  placeholder = "",
  onChange,
  onKeyDown,
  isDisable = false
}) => {
  return (
    <div className="wrap-box">
      <div className="wrap">
        <label className="label" htmlFor={id}>
          {label}
        </label>
        <input
          id={id}
          name={id}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          className="input"
          type={type}
          required={isRequired}
          placeholder={placeholder}
          disabled={isDisable}
        />
      </div>
      <span className="error">{error?.message ?? ""}</span>
    </div>
  );
};
